(() => {
  'use strict';

  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  ready(() => {
    const body = document.body;
    const drawer = document.querySelector('.offcanvas-header');
    const overlay = document.querySelector('.offcanvas-overlay');
    const openButtons = Array.from(document.querySelectorAll('.header__actions_btn--menu, .mobile__menu_bar'));
    const closeButton = drawer?.querySelector('.offcanvas__close_btn');
    let lastTrigger = null;

    const setOpen = (open, trigger = null) => {
      if (!drawer) return;
      if (open) {
        lastTrigger = trigger || document.activeElement;
        drawer.classList.add('open');
        overlay?.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
        body.classList.add('rezfon-menu-open');
        window.setTimeout(() => {
          (drawer.querySelector('.offcanvas__close_btn, a, button, input, select') || drawer).focus?.();
        }, 30);
      } else {
        drawer.classList.remove('open');
        overlay?.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        body.classList.remove('rezfon-menu-open');
        lastTrigger?.focus?.();
      }
    };

    if (drawer) {
      drawer.setAttribute('aria-hidden', drawer.classList.contains('open') ? 'false' : 'true');
      if (!drawer.hasAttribute('role')) drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
    }

    openButtons.forEach((button) => {
      button.setAttribute('aria-controls', 'RezfonMobileDrawer');
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        setOpen(!drawer?.classList.contains('open'), button);
      }, true);
    });

    if (drawer) drawer.id = drawer.id || 'RezfonMobileDrawer';
    closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(false);
    }, true);
    overlay?.addEventListener('click', () => setOpen(false), true);

    document.addEventListener('keydown', (event) => {
      if (!drawer?.classList.contains('open')) return;
      if (event.key === 'Escape') setOpen(false);
      if (event.key === 'Tab') {
        const focusable = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]')).filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 992) setOpen(false);
    }, { passive: true });

    /* Submenus: resilient even when the legacy mobile-nav script fails. */
    drawer?.querySelectorAll('.offcanvas__sub_menu').forEach((submenu) => {
      const parent = submenu.parentElement;
      if (!parent) return;
      let toggle = parent.querySelector(':scope > .offcanvas__sub_menu_toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'offcanvas__sub_menu_toggle';
        toggle.setAttribute('aria-label', 'Untermenü öffnen');
        parent.appendChild(toggle);
      }
      const id = submenu.id || `rezfon-submenu-${Math.random().toString(36).slice(2, 9)}`;
      submenu.id = id;
      toggle.setAttribute('aria-controls', id);
      toggle.setAttribute('aria-expanded', parent.classList.contains('active') ? 'true' : 'false');
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const open = !parent.classList.contains('active');
        parent.classList.toggle('active', open);
        toggle.classList.toggle('active', open);
        toggle.setAttribute('aria-expanded', String(open));
        submenu.style.display = open ? 'block' : 'none';
      }, true);
    });

    /* Close drawer after choosing a normal navigation link. */
    drawer?.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    /* Remove accidental horizontal page overflow from fixed-width app blocks. */
    const clampWideNodes = () => {
      document.querySelectorAll('main table, main iframe, main video, main img').forEach((node) => {
        node.style.maxWidth = '100%';
      });
    };
    clampWideNodes();
    new MutationObserver(clampWideNodes).observe(document.getElementById('MainContent') || body, { childList: true, subtree: true });
  });
})();
